import type { ReactNode, FC } from "react";

import styled from "styled-components";

import { PopupHoverContainer } from "@similarweb/ui-components";

import type { ITrafficShareBarProps } from "../../../../styled components/StyledTrafficShare/src/StyledTrafficShare";

import { TrafficShareTooltipContent } from "./TrafficShareTooltipContent";

/**
 * a Tooltip that that shows TrafficShare bar description
 */

const TrafficShareWrapper = styled.div`
    width: 100%;
    height: 16px;
    display: flex;
`;

interface ITrafficShareTooltipProps {
    title?: string;
    subTitles?: string[];
    trafficShareProps: ITrafficShareBarProps[];
    enabled?: boolean;
    placement?: string;
    cssClass?: string;
    cssClassContent?: string;
    children: ReactNode;
}

export const TrafficShareTooltip: FC<ITrafficShareTooltipProps> = ({
    title,
    subTitles,
    trafficShareProps,
    enabled = true,
    placement = "top",
    cssClass = "trafficShareTooltip-element",
    cssClassContent = "trafficShareTooltip-element-content",
    children,
}) => {
    return (
        <PopupHoverContainer
            content={() => (
                <TrafficShareTooltipContent
                    title={title}
                    trafficShareProps={trafficShareProps}
                    subTitles={subTitles}
                />
            )}
            config={{ enabled, placement, cssClass, cssClassContent }}
        >
            <TrafficShareWrapper>{children}</TrafficShareWrapper>
        </PopupHoverContainer>
    );
};
